var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScanArea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 301.451,
    height: 200.756,
    viewBox: "0 0 301.451 200.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#2148ff;stroke-linecap:round;stroke-width:4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-34.781 -253.82)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-20330.016-18647.439a89.163,89.163,0,0,1,0-11.326c.227-3.389.311-7.387,2.686-9.7,2.436-2.371,6.238-2.352,10.4-2.57,5.449-.289,11.141,0,11.141,0",
    transform: "translate(20367 18927)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-20305.969-18647.439a89.163,89.163,0,0,0,0-11.326c-.227-3.389-.311-7.387-2.686-9.7-2.436-2.371-6.238-2.352-10.4-2.57-5.449-.289-11.141,0-11.141,0",
    transform: "translate(20639.998 18927)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-20305.969-18671.162a89.163,89.163,0,0,1,0,11.326c-.227,3.389-.311,7.387-2.686,9.7-2.436,2.371-6.238,2.352-10.4,2.57-5.449.289-11.141,0-11.141,0",
    transform: "translate(20639.998 19099.998)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-20330.016-18671.162a89.163,89.163,0,0,0,0,11.326c.227,3.389.311,7.387,2.686,9.7,2.436,2.371,6.238,2.352,10.4,2.57,5.449.289,11.141,0,11.141,0",
    transform: "translate(20367 19099.998)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanArea);
export default __webpack_public_path__ + "static/media/scan-area.4de811ccd0700c7404ff619ec0ab4199.svg";
export { ForwardRef as ReactComponent };